import { AtsQuestionInput } from 'generated-graphql/types';
import { AtsJobInput } from 'pages/CandidatesRanking/types';
import { KomboJob, KomboScreeningQuestion } from '../types/komboJob';
import { parseAtsJobDescription } from '../utils';

const formatKomboLocation = (location: KomboJob['location']): string => {
  if (!location) return '';
  return [location.city, location.state, location.country]
    .filter(Boolean)
    .join(', ');
};

// Kombo screening_questions live under `question.format` for type info;
// for now the analysis flow only cares about id / content / required so we
// emit a minimal shape and lose the question type (filled in later if needed).
const mapKomboScreeningQuestions = (
  questions: KomboScreeningQuestion[] | null | undefined
): AtsQuestionInput[] => {
  if (!questions?.length) return [];
  return questions.map((q) => ({
    id: q.id,
    content: q.title ?? q.description ?? '',
    isRequired: !!q.required,
    type: null,
    multipleChoiceAnswers: []
  }));
};

export const mapKomboJobToAtsJobInput = (job: KomboJob): AtsJobInput => {
  const locationName = formatKomboLocation(job.location);
  const jobDescription = parseAtsJobDescription({
    jobTitle: job.name,
    content: job.description ?? '',
    locations: locationName ? [{ id: '1', name: locationName }] : []
  });

  // atsJobPostingId is intentionally omitted in the Kombo case — Kombo's `id`
  // is the job id, not a job-posting id, so reusing it would be misleading.
  // Downstream Kombo writes use `komboJobId` instead.
  return {
    jobDescription,
    atsJobId: job.remote_id,
    atsJobReference: job.job_code ?? undefined,
    atsQuestions: mapKomboScreeningQuestions(job.screening_questions),
    atsJobPostingUrl: job.post_url ?? null,
    komboJobId: job.id
  };
};
